(function ($) {
  var currentPage = 1;
  var isLoading = false;

  function loadMoreProducts() {
    if (isLoading) return;

    isLoading = true;

    currentPage++;
    var url = window.location.href.split("?")[0] + "?page=" + currentPage;

    $.ajax({
      url: url,
      type: "GET",
      success: function (response) {
        var newProducts = $(response).find(
          ".product-list__inner .product-item"
        );
        var newPagination = $(response).find(".pagination");

        if (newProducts.length > 0) {
          $(".product-list__inner").append(newProducts);
          // $('.pagination').replaceWith(newPagination);
          $(".product-list__inner .product-item").css("opacity", "1");

          $("#loader").show();
          // Check if there's no pagination link, meaning we've reached the last page
          var hasNextPage = newPagination.find('a[rel="next"]').length > 0;
          console.log("Has Next Page:", hasNextPage);
          if (!hasNextPage) {
            $("#loader").hide();
            $(".pagination").hide(); // Hide the loader if all pages are loaded
          } else {
            // Otherwise, replace pagination
            $(".pagination").hide();
          }
        } else {
          // If there are no new products (empty response), hide the loader
          $("#loader").hide();
        }
        isLoading = false;
      },
      error: function () {
        isLoading = false;
        $("#loader").hide();
      },
    });
  }

  // Trigger when scroll reaches near bottom
  $(window).on("scroll", function () {
    var nearBottom =
      $(window).scrollTop() + $(window).height() >=
      $(".product-facet").height() - 200;
    if (nearBottom) {
      loadMoreProducts();
    }
  });
})(jQuery);
